import { mapState } from "vuex";

const minin = {
  data() {
    return {
      viewMode: false,
      labelWidth: '180px',
      form: {},
      formCtrl: [],
      formCtrl1: [],
      getOptionUrl: 'addpro',
      getDataUrl: 'item',
      submitUrl: 'addedu',
      mode: '',
      detail: {},
      id: '',
      rules: {
        inton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
        unton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {
    checkTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // if (value == undefined || value == '') {
      //   callback(new Error('请确认密码'));
      // } else
      if (Number(value) > 3000) {
        callback(new Error('重量不能超过3000吨'));
      } else {
        callback();
      }
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        this.form[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
        // } else if (['inton', 'unton'].includes(key) && Number(value) > 60) {
        // this.$message({
        //   type: 'error',
        //   message: '重量不能大于60吨',
        // });
        // return
      } else {
        this.form[key] = value;
      }
      // console.log({ ...this.form });
    },
    formOrtherValidate() {
      return true
    },
    onSubmit() {
      // console.log('form', { ...this.form });
      const boo = this.formOrtherValidate()
      // console.log(boo)
      const validate = this.$refs['form'].validate
      const validatePass = this.$refs['form'].validatePass
      // console.log(this.$refs['form']);
      // console.log(validate);
      // console.log(validatePass);
      if (boo && validate) {
        // 普通表单验证
        validate((valid) => {
          console.log('validate', valid)
          if (valid) {
            this.submitConfirm()
          } else {
            console.log('验证不通过');
            console.log({ ...this.form })
            // this.$message({
            //   type: 'error',
            //   message: '请修改错误信息',
            // });
            return false;
          }
        });
      } else if (boo && validatePass) {
        // MyForm组件表单验证
        validatePass(() => {
          this.submitConfirm()
        });
      }
    },
    submitConfirm() {
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq(data) {
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log(data)
      if (typeof data === 'object') {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onCheckSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs['form'].validate((valid) => {
        const boo = this.formOrtherValidate()
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm('确认审核通过吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.checkSubmitReq({ isfleet: 2 })
          }).catch(() => { });
        } else {
          console.log('验证不通过');
          return false;
        }
      });
    },
    checkSubmitReq(data) {
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log(data)
      if (typeof data === 'object') {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '审核通过!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
      this.paramsPackageHandler(params)
    },
    paramsPackageHandler() {},
    cancel() {
      this.$router.back();
    },
    getDateParamsHandler(params) {
      return params
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/${this.getDataUrl}`;
      const params = {
        userid: this.user.id,
        id: this.id,
      }
      this.getDateParamsHandler(params)
      this.post(url, params, (res) => {
        const { msg, data } = res
        // console.log(res)
        if (msg === 'success' && data) {
          this.detail = data
          this.setDetailOrderData(res)
          this.setDetail()
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setDetail() {
      this.formCtrl.map(v => {
        const key = v.keyName
        this.form[key] = this.detail[key];
      })
      this.formCtrl1.map(v => {
        const key = v.keyName
        this.form[key] = this.detail[key];
      })
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    setDetailOrderData() { },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, {
        userid: this.user.id,
        ...params,
      }, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions() { },
  },
  created() {
    // console.log(this.$route.query);
    const object = this.$route.query
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        this[key] = object[key];
      }
    }
    const { id, mode } = object;
    // console.log(mode)
    if (id) {
      this.id = id
    }
    const b = this.breadcrumb
    this.mode = mode
    if (mode === 'view') {
      this.viewMode = true
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        if (n.includes('编辑')) {
          b[2].name = n.replace('编辑', '查看')
        } else {
          b[2].name = n.replace('添加', '查看')
        }
      }
    } else if (mode === 'edit') {
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        b[2].name = n.replace('添加', '编辑')
      }
    }
  },
  mounted() {
    if (this.id) this.getData();
  },
}

export default minin